import Icon from '@/components/Icon/Icon';

const ChevronDownIcon = ({...rest}) => {
    return (
        <Icon width='16' height='16' fill='none' {...rest}>
            <path d='M13.3334 5.65509L8.00007 10.9884L2.66674 5.65509' stroke='#393E44' strokeLinecap='round' />
        </Icon>
    );
};

export default ChevronDownIcon;
